import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './PartnerStrip.style';

const PARTNERS = [
  {
    key: 'chrono24',
    name: 'Chrono24',
    url: 'https://www.chrono24.de/dealer/michaelruckes/index.htm',
    img: '/assets/images/partners/chrono24-trusted-seller.svg',
  },
  {
    key: 'feinwerk',
    name: 'FEINWERK Servicewerkstatt',
    url: 'https://feinwerk.koeln/',
    img: '/assets/images/partners/feinwerk.png',
  },
  {
    key: 'luxusversicherer',
    name: 'Norman Tontsch, Der Luxusversicherer',
    url: 'https://www.derluxusversicherer.de/',
    img: '/assets/images/partners/luxusversicherer.png',
  },
];

const PartnerStrip: React.FC = () => {
  const { t } = useTranslation();

  return (
    <S.Section data-testid="partner-strip" aria-label="Partner">
      <S.Inner>
        <S.Label>{t('partners.title', 'Unsere Partner')}</S.Label>
        <S.Logos>
          {PARTNERS.map((p) => (
            <S.Partner
              key={p.key}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              title={p.name}
              aria-label={p.name}
              data-testid={`partner-${p.key}`}
            >
              <S.LogoBox>
                <img src={p.img} alt={p.name} loading="lazy" />
              </S.LogoBox>
              <S.PartnerName>{p.name}</S.PartnerName>
            </S.Partner>
          ))}
        </S.Logos>
      </S.Inner>
    </S.Section>
  );
};

export default PartnerStrip;
